// src/pages/ContactPage.jsx

import React, { useState } from 'react';
import { Container, Box, Typography, Link, TextField, Button, Alert } from '@mui/material';
import { submitContact } from '../services/contactService';

export default function ContactPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess('');
    setError('');
    if (!name || !email || !message) {
      setError('Please fill in your name, email and message.');
      return;
    }
    setLoading(true);
    try {
      await submitContact({ name, email, subject, message });
      setSuccess('Thanks! Your message has been sent.');
      setName('');
      setEmail('');
      setSubject('');
      setMessage('');
    } catch (err) {
      setError(err?.response?.data?.error || 'Failed to send your message. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" sx={{ fontWeight: 600, mb: 1 }}>
          Contact Us
        </Typography>
      </Box>

      <Typography variant="body1" sx={{ mb: 2 }}>
        We would love to hear from you. Reach us at:
      </Typography>

      <Typography variant="body1" sx={{ mb: 3 }}>
        Email: <Link href="mailto:support@meet-in.io">support@meet-in.io</Link>
      </Typography>

      {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

      <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <TextField label="Name" value={name} onChange={(e) => setName(e.target.value)} required fullWidth />
        <TextField type="email" label="Email" value={email} onChange={(e) => setEmail(e.target.value)} required fullWidth />
        <TextField label="Subject" value={subject} onChange={(e) => setSubject(e.target.value)} fullWidth />
        <TextField label="Message" value={message} onChange={(e) => setMessage(e.target.value)} required fullWidth multiline minRows={4} />
        <Button type="submit" variant="contained" disabled={loading}>
          {loading ? 'Sending...' : 'Send Message'}
        </Button>
      </Box>

      <Typography variant="body1" sx={{ mt: 3 }}>
        For any privacy related inquiries, see our <Link href="/privacy">Privacy Policy</Link>.
      </Typography>
    </Container>
  );
}


